import { post } from "ThemeSrc/js/api/api";

export const URLS = {
    lead: () => `/api/contact/post/lead`
}

export async function postLead (data) {
    return await post(URLS.lead(), data)
}